import api from "./apis";
import { ERROR_MESSAGE, LOADED, LOADING, SUCCESS_MESSAGE, VALIDATION_ERROR } from "./types";
import history from "../history";

export const getProduct = (p,e,a,n,pr,ds,de) => async (dispatch) => {
 
    dispatch({ type: LOADING });

    try{
      let response = null;
        response = await api(localStorage.getItem("token")).get(`product-management/product?p=${p?p:1}&client=${e?e:""}&active=${a?a:""}&name=${n?n:""}&product=${pr?pr:""}&ds=${ds?ds:""}&de=${de?de:""}`);
        // console.log(response)
        if(response.status === 200 ) {
        dispatch({ type: LOADED });
        return response.data;
        
      }
    }
    catch( err ){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  }